/* Diwali effects.
   1. Click: a firecracker burst (flash, streaks with trails, small pops) wherever the visitor clicks.
   2. Cart: coloured ribbons fall inside the cart drawer after something is added to the cart.
   Both draw on one canvas over the page, never block clicks, and do nothing for visitors
   who prefer reduced motion. */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Deep, saturated colours so the effects show on a white or cream background too.
  var COLORS = ['#D98A00', '#E0A000', '#C2410C', '#185D3D', '#8A6A00'];
  var SPARKS = 20;          // streaks per click
  var GRAVITY = 520;        // px per second squared
  var CLICK_GAP = 120;      // ms between click bursts
  var TRAIL = 7;            // trail length in frames
  var RIBBONS = 70;         // ribbons per cart add
  var RIBBON_DELAY = 350;   // ms after an add, so the drawer has started opening
  var RIBBON_GAP = 400;     // ms between cart bursts

  var canvas = document.createElement('canvas');
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483600';
  document.body.appendChild(canvas);
  var ctx = canvas.getContext('2d');
  var dpr = 1;

  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(window.innerWidth * dpr);
    canvas.height = Math.round(window.innerHeight * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();
  window.addEventListener('resize', resize);

  var sparks = [];
  var flashes = [];
  var ribbons = [];
  var running = false;
  var last = 0;
  var lastRibbon = 0;
  var lastFrame = 0;

  function rand(a, b) { return a + Math.random() * (b - a); }

  function startLoop() {
    if (!running) { running = true; lastFrame = performance.now(); requestAnimationFrame(tick); }
  }

  // ---- Click firecracker -------------------------------------------------------

  function burst(x, y) {
    flashes.push({ x: x, y: y, age: 0, life: 150 });
    for (var i = 0; i < SPARKS; i++) {
      var angle = rand(0, Math.PI * 2);
      var speed = rand(160, 380);
      sparks.push({
        x: x, y: y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        age: 0,
        life: rand(650, 850),
        color: COLORS[(Math.random() * COLORS.length) | 0],
        width: rand(1.0, 1.6),
        trail: [],
        popped: false
      });
    }
    startLoop();
  }

  // A small secondary pop when a streak is almost out, like a firecracker crackle.
  function pop(s) {
    for (var i = 0; i < 5; i++) {
      var angle = rand(0, Math.PI * 2);
      var speed = rand(60, 130);
      sparks.push({
        x: s.x, y: s.y,
        vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed,
        age: 0, life: rand(250, 350),
        color: s.color, width: 0.9, trail: [], popped: true
      });
    }
  }

  // ---- Cart ribbons -------------------------------------------------------------

  // The cart drawer's box on screen, or null when it isn't visible.
  function drawerBox() {
    var el = document.querySelector('.cart-drawer__content');
    if (!el) return null;
    var r = el.getBoundingClientRect();
    return r.width > 40 && r.height > 40 ? r : null;
  }

  function ribbonBurst() {
    var now = Date.now();
    if (now - lastRibbon < RIBBON_GAP) return;
    var box = drawerBox();
    if (!box) return;
    lastRibbon = now;
    for (var i = 0; i < RIBBONS; i++) {
      // Each ribbon rolls in a circle while it falls: its centre drops, and it orbits that centre.
      ribbons.push({
        cx: rand(box.left, box.right), cy: rand(box.top - 40, box.top),
        radius: rand(10, 26), theta: rand(0, Math.PI * 2),
        omega: (Math.random() < 0.5 ? -1 : 1) * rand(5, 9),
        vy: rand(200, 320), drift: rand(-30, 30),
        flutter: rand(0, Math.PI * 2), flutterSpeed: rand(6, 10),
        w: rand(3, 4.5), h: rand(9, 14),
        age: 0, life: rand(1400, 1800),
        color: COLORS[(Math.random() * COLORS.length) | 0]
      });
    }
    startLoop();
  }

  // Fire the ribbon after any successful add-to-cart request (theme, sticky bar or this page's buttons).
  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var request = nativeFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      request.then(function (r) {
        if (r && r.ok) setTimeout(ribbonBurst, RIBBON_DELAY);
      }).catch(function () {});
    }
    return request;
  };

  // ---- Animation loop ------------------------------------------------------------

  function tick(now) {
    var dt = Math.min((now - lastFrame) / 1000, 0.05);
    lastFrame = now;
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

    // Flashes: a warm glow at the click point that fades out fast.
    flashes = flashes.filter(function (f) {
      f.age += dt * 1000;
      var t = f.age / f.life;
      if (t >= 1) return false;
      var alpha = (1 - t) * 0.55;
      var r = 5 + t * 11;
      var g = ctx.createRadialGradient(f.x, f.y, 0, f.x, f.y, r);
      g.addColorStop(0, 'rgba(255,214,120,' + alpha + ')');
      g.addColorStop(1, 'rgba(255,214,120,0)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(f.x, f.y, r, 0, Math.PI * 2);
      ctx.fill();
      return true;
    });

    // Sparks: move, fall, leave a trail, then fade out.
    var drag = Math.pow(0.985, dt * 60);
    var pending = [];
    sparks = sparks.filter(function (s) {
      s.age += dt * 1000;
      if (s.age >= s.life) return false;
      s.vx *= drag;
      s.vy = s.vy * drag + GRAVITY * dt;
      s.x += s.vx * dt;
      s.y += s.vy * dt;
      s.trail.push({ x: s.x, y: s.y });
      if (s.trail.length > TRAIL) s.trail.shift();

      var t = s.age / s.life;
      var alpha = 1 - t;
      for (var i = 1; i < s.trail.length; i++) {
        var a = s.trail[i - 1], b = s.trail[i];
        ctx.strokeStyle = s.color;
        ctx.globalAlpha = alpha * (i / s.trail.length);
        ctx.lineWidth = s.width * (i / s.trail.length) + 0.4;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(a.x, a.y);
        ctx.lineTo(b.x, b.y);
        ctx.stroke();
      }
      // Bright head of the streak.
      ctx.globalAlpha = alpha;
      ctx.fillStyle = s.color;
      ctx.beginPath();
      ctx.arc(s.x, s.y, s.width * 0.9, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalAlpha = 1;

      if (!s.popped && t > 0.72) { s.popped = true; pending.push(s); }
      return true;
    });
    // Add the secondary pops after the filter, so they aren't dropped by it.
    pending.forEach(pop);

    // Ribbons: fall, sway and flutter, clipped to the cart drawer so they never leave it.
    if (ribbons.length) {
      var box = drawerBox();
      if (!box) {
        ribbons = [];
      } else {
        ctx.save();
        ctx.beginPath();
        ctx.rect(box.left, box.top, box.width, box.height);
        ctx.clip();
        ribbons = ribbons.filter(function (r) {
          r.age += dt * 1000;
          if (r.age >= r.life || r.cy > box.bottom + 40) return false;
          r.cx += r.drift * dt;
          r.cy += r.vy * dt;
          r.theta += r.omega * dt;
          r.flutter += r.flutterSpeed * dt;
          var x = r.cx + Math.cos(r.theta) * r.radius;
          var y = r.cy + Math.sin(r.theta) * r.radius;
          var t = r.age / r.life;
          ctx.save();
          ctx.globalAlpha = t > 0.75 ? (1 - t) * 4 : 1;
          ctx.translate(x, y);
          ctx.rotate(r.theta);
          ctx.scale(1, Math.max(0.15, Math.abs(Math.cos(r.flutter))));
          ctx.fillStyle = r.color;
          ctx.fillRect(-r.w / 2, -r.h / 2, r.w, r.h);
          ctx.restore();
          return true;
        });
        ctx.restore();
      }
    }

    if (sparks.length || flashes.length || ribbons.length) {
      requestAnimationFrame(tick);
    } else {
      running = false;
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    }
  }

  document.addEventListener('pointerdown', function (e) {
    if (e.button > 0) return; // left click or touch only
    var now = Date.now();
    if (now - last < CLICK_GAP) return;
    last = now;
    burst(e.clientX, e.clientY);
  }, { passive: true });
})();
